import { resolutionStatuses } from "../../../utils/vars";

export const RESOLUTION_STATUS_OPTIONS = Object.entries(resolutionStatuses).map(
  ([value, label]) => ({ value, label }),
);
